<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>业务员账号列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- <el-row :gutter="20" v-if="canLook == 1">
        <el-col :span="3">
          <el-button type="primary" @click="addDialogVisible = true">添加业务员</el-button>
        </el-col>

        <el-col :span="4" v-if="canLook == 1">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadURL"
            :headers="headerObj"
            accept=".xlsx"
            :limit="1"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :on-error="handleError"
            :file-list="fileList"
          >
            <el-button type="primary">批量上传</el-button>
          </el-upload>
        </el-col>
        <el-col :span="6"> </el-col>
      </el-row> -->

      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe>
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column
          label="uuid"
          prop="uuid"
          width="120px"
        ></el-table-column>
        <el-table-column
          label="名称"
          prop="name"
          width="80px"
        ></el-table-column>
        <el-table-column
          label="电话"
          prop="phone"
          width="100px"
        ></el-table-column>
        <el-table-column
          label="区域"
          prop="townName"
          width="100px"
        ></el-table-column>
        <el-table-column label="说明" prop="tip"></el-table-column>
        <el-table-column
          label="邀请码"
          prop="salesmanCode"
          width="80px"
        ></el-table-column>
        <el-table-column
          label="申请时间"
          prop="create_at"
          width="120px"
        ></el-table-column>
        <el-table-column label="状态" width="90px" v-if="canLook == 1">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">等待审核</div>
            <div v-if="scope.row.status == 1">通过</div>
            <div v-if="scope.row.status == 2">
              拒绝-{{ scope.row.refuseTip }}
            </div>
            <!-- <el-switch v-model="scope.row.status" @change="userStateChanged(scope.row)"> </el-switch> -->
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="postPass(scope.row.id)"
              >通过</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="remfuseUserById(scope.row.id)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog
      title="拒绝理由"
      :visible.sync="refuseDialogVisible"
      width="50%"
      @close="refuseDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="refuseForm"
        :rules="refuseFormRules"
        ref="refuseFormRef"
        label-width="130px"
      >
        <el-form-item label="理由" prop="refuseTip">
          <el-input v-model="refuseForm.refuseTip"></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postRefuse">拒绝</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canLook: 1,
      uploadURL: "https://hsapi.hsxsn.cn/common/uploadFile",
      // 图片上传组件的headers请求头对象
      headerObj: {
        Authorization: window.sessionStorage.getItem("token"),
      },

      // 获取用户列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },

      userlist: [],
      total: 0,

      // 控制添加用户对话框的显示与隐藏
      refuseDialogVisible: false,
      // 添加用户的表单数据
      refuseForm: {
        id: null,
        status: 2,
        refuseTip: "",
      },

      // 添加表单的验证规则对象
      refuseFormRules: {
        refuseTip: [{ required: true, message: "请输入理由", trigger: "blur" }],
      },
    };
  },

  created() {
    this.getUserList();
  },

  methods: {
    async getUserList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get(
        "admin/users/getAllSalesmanList"
      );
      if (res.code !== 200) {
        return this.$message.error("用户列表！");
      }
      this.userlist = res.result.list;

      this.total = res.result.count;
      console.log(res);
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getUserList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getUserList();
    },

    remfuseUserById(id) {
      this.refuseForm.id = id;
      this.refuseDialogVisible = true;
    },

    // 监听添加用户对话框的关闭事件
    refuseDialogClosed() {
      this.refuseDialogVisible = false;
      this.$refs.refuseFormRef.resetFields();
    },

    // 拒绝
    postRefuse() {
      this.$refs.refuseFormRef.validate(async (valid) => {
        if (!valid) return; 
        const { data: res } = await this.$http.post(
          "admin/users/updateSalesmanStatus",
          this.refuseForm
        );
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.$message.success(res.message);
        this.refuseDialogVisible = false;
        this.getUserList();
      });
    },
     // 通过
     async postPass(id) {
      
        // 可以发起添加用户的网络请求
        const { data: res } =await this.$http.post(
          "admin/users/updateSalesmanStatus",
          {
            id:id,
            status:1,
            refuseTip:''
          }
        );
        if (res.code !== 200) {
          this.$message.error(res.message);
          return;
        }
        this.$message.success(res.message); 
        this.getUserList(); 
    },
  },
};
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}
</style>
